import type { JSX } from 'react'

export const CheckIcon = (): JSX.Element => (
  <use href='#checkIcon' height='100%' width='100%' />
)
